"use client"

import { useEffect } from "react"

type TProps = {
  title?: string
  description?: string
  image?: string
  url?: string
}

// The Pages Router's `next/head` does not work in the App Router, so titles are
// applied on the client. `AppHead` overrides these defaults when a page declares meta.
export function Head(props: TProps) {
  const title = props.title || "Team-Tracker"
  const description = props.description || "Make your team better"

  useEffect(() => {
    document.title = title

    let meta = document.querySelector('meta[name="description"]')
    if (!meta) {
      meta = document.createElement("meta")
      meta.setAttribute("name", "description")
      document.head.appendChild(meta)
    }
    meta.setAttribute("content", description)
  }, [title, description])

  return null
}
